<template>
  <div class="upload_wrap">
    <!-- 图片上传组件辅助-->
    <el-upload class="avatar-uploader" :action="uploadUrl+action" name="file"  :headers="header" :show-file-list="false" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload" :disabled="quillUpdateImg">
      <div v-if="imageUrl" class="img_box">
        <!-- <img :src="imageUrl" class="avatar" /> -->
        <el-image style="width: 80px; height: 80px" :src="`${uploadUrl}/upload/download?id=${imageUrl}&openStyle=1`" fit="scale-down"></el-image>
        <i class="close_btn el-icon-error" @click.stop="closeFn" style="font-size: 20px; color: red"></i>
        <i v-if="quillUpdateImg" class="loading_icon el-icon-loading avatar-uploader-icon" style="font-size: 45px; color: #999"></i>
      </div>
      <template v-else>
        <i v-if="!quillUpdateImg" class="el-icon-plus avatar-uploader-icon"></i>
        <i v-if="quillUpdateImg" class="el-icon-loading avatar-uploader-icon" style="font-size: 45px; color: #999"></i>
      </template>
    </el-upload>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String|Number,
    },
    action: {
      type: String,
      default: "/upload/uploadToLocal",
    },
  },
  data() {
    return {
      imageUrl: this.value,
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      header: {}, // token: sessionStorage.getItem("token")
      fileType:null
    };
  },
  watch: {
    value: function (val) {
      this.imageUrl = val;
    },
    imageUrl: function (val) {
      this.$emit("img-event", val);
    },
  },
  methods: {
    closeFn() {
      this.imageUrl = "";
    },
    beforeUpload(file) {
      this.fileType = file.type
      console.log(this.fileType,'文件格式')
      this.quillUpdateImg = true;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif" || file.type === "application/pdf";
      const isLt2M = true; //file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("图片只能是 jpg/png/gif/pdf 格式!");
        this.quillUpdateImg = false;
      }
      if (!isLt2M) {
        this.$message.error("图片大小不能超过 2MB!");
        this.quillUpdateImg = false;
      }
      return isJPG && isLt2M;
    },
    uploadSuccess(res) {
      // this.imageUrl = URL.createObjectURL(file.raw);
      if (res.code == 200) {
        this.$message.success("上传成功");
        this.imageUrl = res.data[0];
      } else {
        this.$message.error("上传失败");
      }
      this.quillUpdateImg = false;
    },
    uploadError() {
      this.quillUpdateImg = false;
      this.$message.error("上传失败");
    },
  },
};
</script> 

<style scoped>
.upload_wrap >>> .img_box {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload_wrap >>> .loading_icon {
  position: absolute;
}
.upload_wrap >>> .close_btn {
  position: absolute;
  top: -8px;
  right: -8px;
}
.upload_wrap >>> .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 0;
  cursor: pointer;
  position: relative;
  overflow: inherit;
  max-height: 200px;
  max-width: 200px;
}
.upload_wrap >>> .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.upload_wrap >>> .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
}
.upload_wrap >>> .avatar {
  width: 100%;
  height: 100%;
  display: block;
}
</style>